import { useApiQuery } from 'mf_core/query';

export function useBillingAddressByCNPJ(cnpjNumber: string, enabled: boolean) {
  return useApiQuery<any[]>(
    `/account-management/v1/resellers/reseller-billing-address-by-cnpj?cnpjNumber=${cnpjNumber}`,
    undefined,
    { enabled, refetchOnWindowFocus: false }
  );
}
